
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stress-test-start",
      function () {
        return require("private-next-pages/stress-test-start.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stress-test-start"])
      });
    }
  